import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/motion";
import { PageHero, CtaBand } from "../components/shared";
import { img } from "../data/site";

/* Dichiarazione di accessibilità (WCAG 2.1 AA) — collegata nel footer. */
export default function Accessibilita() {
  return (
    <>
      <PageHero
        kick="Accessibilità"
        lines={["Dichiarazione di", "accessibilità."]}
        sub="Orion Security srl si impegna a rendere il proprio sito accessibile e utilizzabile dal maggior numero di persone possibile, nel rispetto dei requisiti di accessibilità (WCAG 2.1 livello AA)."
        ph={img("sede-san-cesareo-drone-1.jpg")}
        testid="accessibilita-hero"
      />

      <section className="sec" data-testid="accessibilita-stato">
        <div className="wrap" style={{ maxWidth: 900 }}>
          <div style={{ color: "var(--muted)", display: "grid", gap: 26 }} data-testid="accessibilita-content">
            <div>
              <h2 className="h3" style={{ color: "var(--text)", marginBottom: 10 }}>Stato di conformità</h2>
              <p style={{ margin: 0 }}>
                Questo sito è progettato per rispettare le linee guida <strong>WCAG 2.1 livello AA</strong>.
                La conformità è stata verificata con strumenti automatici (Lighthouse e axe) e con prove manuali
                di navigazione da tastiera e con lettori di schermo. Lo stato attuale è <strong>conformità parziale</strong>:
                alcuni contenuti di terze parti sono descritti nella sezione limitazioni.
              </p>
            </div>
            <div>
              <h2 className="h3" style={{ color: "var(--text)", marginBottom: 10 }}>Misure adottate</h2>
              <ul style={{ margin: 0, paddingLeft: 22, display: "grid", gap: 10 }}>
                <li>Navigazione completa con la sola tastiera e indicatore di focus ben visibile (contorno azzurro 3px).</li>
                <li>Link "Vai al contenuto" a inizio pagina per saltare il menu.</li>
                <li>Nei pannelli (menu, preventivo, banner cookie) il focus resta all'interno, con tasto Esc per chiudere e ritorno del focus al pulsante di apertura.</li>
                <li>Contrasto dei testi almeno 4,5:1 (3:1 per i titoli di grandi dimensioni).</li>
                <li>Moduli con etichette visibili collegate ai campi e messaggi di errore in forma testuale.</li>
                <li>Testi alternativi descrittivi per le immagini significative e alternativi vuoti per quelle decorative.</li>
                <li>Un solo titolo H1 per pagina e gerarchia dei titoli ordinata; lingua della pagina: italiano.</li>
                <li>Pulsante "Metti in pausa" sui video di sfondo delle copertine.</li>
                <li>Contenuto utilizzabile con il testo ingrandito al 200% senza sovrapposizioni.</li>
              </ul>
            </div>
            <div>
              <h2 className="h3" style={{ color: "var(--text)", marginBottom: 10 }}>Limitazioni note</h2>
              <p style={{ margin: 0 }}>
                La chat dell'assistente è un servizio di terze parti (Keplero): ne monitoriamo l'usabilità, ma
                alcuni aspetti interni dipendono dal fornitore. Per gli stessi motivi, i contenuti dei siti esterni
                del gruppo (Axentra, Astra) non rientrano in questa dichiarazione.
              </p>
            </div>
            <div>
              <h2 className="h3" style={{ color: "var(--text)", marginBottom: 10 }}>Segnalazioni</h2>
              <p style={{ margin: 0 }}>
                Se incontri difficoltà nell'uso del sito, scrivi a{" "}
                <a href="mailto:commerciale@security.it">commerciale@security.it</a>: ci aiuti a migliorare e
                ti risponderemo entro 30 giorni. Per approfondire, consulta la{" "}
                <Link to="/privacy">Privacy Policy</Link> e la pagina <Link to="/cookie">Cookie</Link>.
              </p>
              <p style={{ margin: 0, fontSize: 14 }}>Dichiarazione redatta il 12 ottobre 2026, aggiornata al rilascio della versione corrente del sito.</p>
            </div>
          </div>
        </div>
      </section>

      <CtaBand testid="accessibilita-cta" />
    </>
  );
}
